export default {
  contacts: [],
  projects: [],
  bankAccounts: [],
  filterBy: 'Uncoded',
  apiError: false,
  loadCompleted: false,
  timeStamp: 0,
  rules: [],
  comments: [],
  matchables: {
    bills: [],
    invoices: [],
    undeposited: [],
    // Per list, so a failure of one request no longer hides the lists that loaded.
    // `requests` holds the newest request id per list, so responses from superseded
    // requests can be recognised and dropped.
    requests: {},
    loading: {},
    errors: {},
    apiError: false,
    loadCompleted: false,
  },
  matches: [],
  removeMatchList: [],
  matchLoadingList: [],
  selectedTransactions: [],
  codingErrors: [],
  status: { posting: false, success: false },
  xpa: { bankAccounts: [] },
  rah: {
    pollInterval: 6,
    syncing: false,
    LastSync: {
      contact: undefined,
      chart: undefined,
      classification: undefined,
      bankaccounts: undefined,
      transactions: undefined
    },
    queueState: {
      retryError: undefined,
      retryableCount: 0
    }
  },
  bankfeeds: {},
  };


// WEBPACK FOOTER //
// ./src/reducers/initial-state.js